const normalizeBaseUrl = (value = "") => String(value).trim().replace(/\/+$/, "");

export const buildCertificateVerificationUrl = (code) => {
  const configuredBaseUrl = normalizeBaseUrl(process.env.REACT_APP_PUBLIC_BASE_URL || "https://help.edu.gov.af");
  const baseUrl = configuredBaseUrl || "https://help.edu.gov.af";
  const normalizedCode = String(code || "").trim().toUpperCase();
  if (!baseUrl || !normalizedCode) return "";
  const url = new URL(`${baseUrl}/certificates/verify`);
  url.searchParams.set("code", normalizedCode);
  return url.toString();
};
